import React from "react";

const AuraNails = () => {
  return (
    <div className="blogWhat-content">
      <h5>2. Aura Nails: Mystical & Mesmerizing</h5>
      <p>
        Inspired by the halo effect of energy fields, aura nails feature an
        <a href="https://scentlifestyle.com/ombre-gel-nail-polish">
          ombré-style glow in the center of the nail
        </a>
        . This dreamy, gradient effect can be created in vibrant colors like
        pink, blue, or green, making it a favorite for those who love a
        spiritual and aesthetic nail design. Whether you go for bold, neon
        shades or soft pastels, aura nails are an absolute must-try.
      </p>
    </div>
  );
};

export default AuraNails;
